import { signal } from '@preact/signals-react';

export const isLoading = signal(false);
export const loadingCount = signal(0);